@if (link(); as linkElement) {
  <div class="link-value">
    <label class="link-value__title" for="link-value" ttLabel>{{ 'Value' | transloco }}:</label>
    @if (loading()) {
      <tt-spinner class="link-value__spinner" [size]="32" />
    } @else {
      @if (decisionRuleType() && decisionRuleType() !== RuleType.Boolean && decisionRuleType() !== RuleType.String) {
        <tt-select [ngModel]="displayOperator()" (ngModelChange)="onOperatorChange($event)">
          <tt-select-items>
            @for (select of selects(); track select.value) {
              <tt-option [value]="select.value">{{ select.translationText | transloco }}</tt-option>
            }
          </tt-select-items>
        </tt-select>
      }

      @if (decisionODType() !== undefined && decisionODType() >= 0 && decisionODType() !== ObservationPermittedDataType.Boolean) {
        <tt-select [ngModel]="displayOperator()" (ngModelChange)="onOperatorChange($event)">
          <tt-select-items>
            @for (select of selects(); track select.value) {
              <tt-option [value]="select.value">{{ select.translationText | transloco }}</tt-option>
            }
          </tt-select-items>
        </tt-select>
      }

      @if (shouldShowInput()) {
        <div class="link-value__inputs">
          <div class="link-value__input">
            @switch (inputType()) {
              @case ('number') {
                <input
                  class="link-value__input--element"
                  id="link-value"
                  step=".01"
                  ttInput
                  type="number"
                  [ngModel]="displayValue()"
                  (ngModelChange)="onLinkValueChange($event)" />
              }
              @case ('table') {
                <app-value-set-picker
                  [selectedValues]="selectedValues()"
                  [valueSetCode]="sourceDecision().guidelineObservation.observationDefinition.codeableConceptCode"
                  (valuesSelected)="valueSetValuesSelected($event)" />
              }
              @case ('text') {
                <input
                  class="link-value__input--element"
                  id="link-value"
                  step=".01"
                  ttInput
                  type="text"
                  [ngModel]="displayValue()"
                  (ngModelChange)="onLinkValueChange($event)" />
              }
            }

            @if (decisionUnit()) {
              <span class="link-value__input--unit">{{ decisionUnit() }}</span>
            }
          </div>

          @if (inputType() === 'number' && linkElement.attribute?.operator === FlowchartLinkAttributeOperator.Between) {
            <mat-icon [icon]="'minus'" [iconSize]="8" />
            <div class="link-value__input">
              <input
                class="link-value__input--element"
                id="link-value-to"
                step=".01"
                ttInput
                type="number"
                [ngModel]="displayValueTo()"
                (ngModelChange)="onLinkToValueChange($event)" />
              @if (decisionUnit()) {
                <span class="link-value__input--unit">{{ decisionUnit() }}</span>
              }
            </div>
          }
        </div>
      }

      @if (shouldShowButtons()) {
        <div class="link-value__button-container">
          <button
            class="link-value__button"
            type="button"
            [class.selected]="linkValue()?.booleanValue === true"
            (click)="onLinkButtonValueChange(true)">
            {{ 'Yes' | transloco }}
          </button>
          <button
            class="link-value__button"
            type="button"
            [class.selected]="linkValue()?.booleanValue === false"
            (click)="onLinkButtonValueChange(false)">
            {{ 'No' | transloco }}
          </button>
        </div>
      }
    }
  </div>
}
